package net.sergeych.bintools

class FormatException(message: String="invalid format",cause: Throwable?=null):
        Exception(message, cause)